import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "className", "monospace", "runningText", "large", "small", "showSkeleton", "muted", "disabled", "ellipsis"];
import React from 'react';
import styled, { css } from 'styled-components';
import { color, display, flex, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, maxHeight, maxWidth, minHeight, minWidth, opacity, space, textAlign, themeGet, width } from 'styled-system';
import { Classes } from '@blueprintjs/core';
import classNames from 'classnames';
import { textDecoration, textOverflow, textTransform, whiteSpace } from './utils/typography';
var StyledText = styled.span.withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-1vz74b3-0"
})(["&&{", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", "}"], space, width, flex, fontSize, display, fontWeight, color, textTransform, textDecoration, textAlign, fontStyle, letterSpacing, lineHeight, opacity, whiteSpace, textOverflow, minHeight, maxHeight, minWidth, maxWidth, function (_ref) {
  var hoverColor = _ref.hoverColor;
  return hoverColor && css(["&:hover{color:", ";}"], themeGet("colors.".concat(hoverColor), hoverColor));
});
var Text = function Text(_ref2) {
  var _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'span' : _ref2$as,
    className = _ref2.className,
    monospace = _ref2.monospace,
    runningText = _ref2.runningText,
    large = _ref2.large,
    small = _ref2.small,
    showSkeleton = _ref2.showSkeleton,
    muted = _ref2.muted,
    disabled = _ref2.disabled,
    ellipsis = _ref2.ellipsis,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var fontSizeProp = rest.fontSize;
  if (monospace && small) {
    fontSizeProp = 10;
  }
  return /*#__PURE__*/React.createElement(StyledText, _extends({
    as: as
  }, rest, {
    fontSize: fontSizeProp,
    className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Classes.MONOSPACE_TEXT, monospace), Classes.RUNNING_TEXT, runningText), Classes.TEXT_LARGE, large), Classes.TEXT_SMALL, small), Classes.TEXT_MUTED, muted), Classes.TEXT_DISABLED, disabled), Classes.TEXT_OVERFLOW_ELLIPSIS, ellipsis), Classes.SKELETON, showSkeleton), className)
  }));
};
export default Text;